import { oc } from "@orpc/contract";
import { openapi } from "@orpc/openapi";
import { z } from "zod";
import { publicIdSchema } from "./public-id";

const id = publicIdSchema;
// Deprecated (ROSC-144): accepted from old clients but ignored. The server
// chooses the speech-to-text provider and model by visit language.
export const deprecatedTranscriptionProviderIdSchema = z
  .enum([
    "openai/gpt-4o-transcribe",
    "elevenlabs/scribe_v1",
    "deepgram/nova-3-medical",
    "deepgram/nova-3",
    "deepgram/nova-2",
  ])
  .meta({
    deprecated: true,
    description:
      "Deprecated and ignored. The server chooses the speech-to-text provider.",
  });
export const transcriptionRetrySchema = z.strictObject({
  /** @deprecated Ignored; the server chooses the provider (ROSC-144). */
  providerId: deprecatedTranscriptionProviderIdSchema.optional(),
});
export type TranscriptionRetryBody = z.output<typeof transcriptionRetrySchema>;
export const transcriptionRetryResultSchema = z.object({
  public_id: id,
  mode: z.enum(["audio", "notes"]),
});
export const transcriptionRetryContract = {
  createTranscription: oc
    .errors({
      BAD_REQUEST: { message: "Invalid request" },
      UNAUTHORIZED: { message: "Authentication required" },
      FORBIDDEN: { message: "Account required" },
      NOT_FOUND: { message: "Visit not found" },
      CONFLICT: { message: "Transcription request conflict" },
      SERVICE_UNAVAILABLE: { message: "Transcription retry unavailable" },
      METHOD_NOT_ALLOWED: { message: "Method Not Allowed" },
      INTERNAL_SERVER_ERROR: { message: "Internal Server Error" },
    })
    .input(
      z.object({
        params: z.strictObject({
          public_id: publicIdSchema,
        }),
        query: z.strictObject({}).default({}),
        headers: z.object({ "idempotency-key": z.uuid().toLowerCase() }),
        body: transcriptionRetrySchema,
      }),
    )
    .meta(
      openapi({
        method: "POST",
        path: "/api/v2/visits/{public_id}/transcriptions",
        inputStructure: "detailed",
        successStatus: 201,
        spec: (spec) => ({ ...spec, security: [{ bearerAuth: [] }] }),
      }),
    )
    .output(transcriptionRetryResultSchema),
};
